import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { ServiceClass } from '@ragu-components/ord-types';

const ServiceClassesList = React.lazy(async () => import('./ServiceClassesList'));

export const serviceClassesResource: OrdResourceProps = {
  key: Resources.service_classes,
  name: Resources.service_classes,
  list: <ServiceClassesList />,
  options: {},
  recordRepresentation: (record: ServiceClass) => `${record.name}${record.is_default === true ? ' [default]' : ''}`,
};
